module.exports = __webpack_public_path__ + "img/ic-play.e1c488f5.svg";